<script lang="ts" setup>
import LabelTag from "~/components/form/LabelTag.vue";
import InputTag from "~/components/form/InputTag.vue";
import ButtonPrimary from "~/components/ButtonPrimary.vue";
import axios from "axios";
import { navigateTo, useRoute } from "#app";

definePageMeta({
    middleware: "guest",
});

// Data
const route = useRoute();
const config = useRuntimeConfig();
const form = ref({
    email: "",
    password: "",
    password_confirmation: "",
    token: "",
});
const msg = ref("");

// Functions
async function resetPassword() {
    try {
        form.value.email = decodeURI(String(route.query["email"]));
        form.value.token = String(route.query["token"]);
        const { data: response } = await axios.post(config.public.STATAMIC_API + "/reset-password", form.value);

        if (!response.status) {
            msg.value = '<div class="text-abc-red"> ' + response.message + "</div>";
        } else {
            msg.value = "";
            navigateTo("/account");
        }
    } catch (e: any) {
        console.log(e);
        if (e.response.status == 422 && e.response.data.errors) {
            const aryErrors = [];
            for (const [key, value] of Object.entries(e.response.data.errors)) {
                aryErrors.push(value.join("<br/>"));
            }
            msg.value = '<div class="text-abc-red">' + aryErrors.join("<br/>") + "</div>";
        }
    }
}
</script>

<template>
    <div>
        <H1Heading class="mb-8 text-center">Reset Password</H1Heading>

        <form class="mx-auto md:w-96" @submit.prevent="resetPassword">
            <div class="mt-4">
                <LabelTag for="password">New Password</LabelTag>
                <InputTag
                    id="password"
                    v-model="form.password"
                    type="password"
                    class="w-full"
                    placeholder="Enter password"
                    required
                />
            </div>
            <div class="mt-4">
                <LabelTag for="password_confirmation">Confirm Password.</LabelTag>
                <InputTag
                    id="password_confirmation"
                    v-model="form.password_confirmation"
                    type="password"
                    class="w-full"
                    placeholder="Enter password"
                    required
                />
            </div>

            <div class="mt-4 mb-6 text-center" v-html="msg"></div>

            <div class="text-center">
                <ButtonPrimary type="submit" class="w-full md:w-1/2">OK</ButtonPrimary>
            </div>
        </form>
    </div>
</template>

<style scoped></style>
